module.exports = __webpack_public_path__ + "media/app/assets/specializations/demon_hunter/havoc-11edad255f5807e0c660c696214a8389.png";